import React from "react";
import TabSchema from "../tabSchema";
import Users from "./users/users";
import Roles from "./roles/roles";

export default function ManageUsers(operationPermissions) {
  const manageUsersTab = [
    {
      label: "Users",
      value: "0",
      content: <Users operationPermissions={operationPermissions} />,
    },
    {
      label: "Roles",
      value: "1",
      content: <Roles operationPermissions={operationPermissions} />,
    },
  ];
  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content">
          <div
            style={{
              width: "100%",
              marginTop: "-10px",
            }}
          >
            <TabSchema tabs={manageUsersTab} tabKey="manageUsers" />
          </div>
        </section>
      </div>
    </>
  );
}
